import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, taught the type scale.
 *
 * WITHOUT THIS IT DELETES FONT SIZES. It only knows Tailwind's default `text-*` sizes, so it reads
 * `text-heading` or `text-label` as a COLOUR — and when a real colour such as `text-ink-muted`
 * follows it in the same call, it keeps the last "colour" and silently drops the size. A dimmed
 * `$0.00` rendered at the inherited 14px instead of 24px is how this was found. The names here are
 * the `@theme` sizes in tokens.css and must move with them.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display-lg', 'display', 'heading', 'body', 'body-sm', 'label'] }],
    },
  },
});

/** Merge Tailwind classes so a caller's `className` always wins over the component default. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
